import React from 'react';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';

import CheckoutButton from '../containers/withNewCheckoutButton';
import { nullFunc } from '../../utils/helpers';

/*
* Unfortunately there's no way to execute validations before showing stripe modal using react-stripe-checkout
* This guarded button hides the original button and hits it via ref only in case validation is successful
*/
class GuardedCheckoutButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { disabled: false };
  }
  onClick = () => {
    this.setState({ disabled: true });
    this.props.validate().then(() => {
      this.ref.click();
    }).finally(() => this.setState({ disabled: false }));
  };

  getCheckoutButtonProps = () => {
    const list = ['onSuccess', 'currency', 'amount', 'panelLabel', 'email'];
    return pick(this.props, list);
  };

  setRef = ref => (this.ref = ref);

  render() {
    return (
      <div>
        <CheckoutButton
          {...this.getCheckoutButtonProps()}
          className="is-hidden"
          action={this.props.action}
          showPromo={this.props.showPromo}
          onBeforeClose={this.props.onBeforeClose}
          onBeforeOpen={this.props.onBeforeOpen}
        >
          <span ref={this.setRef} />
        </CheckoutButton>
        <button
          type="button"
          className={this.props.className}
          disabled={this.props.disabled || this.state.disabled}
          onClick={this.onClick}
        >
          {this.props.children}
          {this.state.disabled &&
            <Spinner spinnerName="triple-bounce" noFadeIn />}
        </button>
      </div>
    );
  }
}

GuardedCheckoutButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  validate: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  showPromo: PropTypes.bool,
  onBeforeOpen: PropTypes.func,
  onBeforeClose: PropTypes.func,
  action: PropTypes.string,
};

GuardedCheckoutButton.defaultProps = {
  className: '',
  disabled: false,
  showPromo: false,
  onBeforeOpen: nullFunc,
  onBeforeClose: nullFunc,
  action: 'reserveAndPay',
};

export default GuardedCheckoutButton;



// WEBPACK FOOTER //
// ./src/app/reservation/components/GuardedCheckoutButton.jsx